// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1vtAN","footer":"ChangeClinic_footer__1NZ7S"};